import React from "react";

import ReactDOM from "react-dom/client";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from './App';
import "./index.css"
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>
</StrictMode>
);